var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg091Undo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99996 16C7.2672 15.9989 7.52289 15.8908 7.70996 15.7C8.09768 15.3099 8.09768 14.68 7.70996 14.29L4.37996 11H14.51C16.9952 11 19.01 13.0147 19.01 15.5C19.01 17.9853 16.9952 20 14.51 20H12C11.4477 20 11 20.4477 11 21C11 21.5523 11.4477 22 12 22H14.51C18.0998 22 21.01 19.0898 21.01 15.5C21.01 11.9101 18.0998 8.99997 14.51 8.99997H4.36996L7.69996 5.70997C8.04275 5.31565 8.02419 4.72389 7.65736 4.35183C7.29054 3.97976 6.6991 3.95281 6.29996 4.28997L1.22996 9.28997C1.04277 9.47869 0.938421 9.73417 0.939958 9.99997C0.941068 10.2672 1.0491 10.5229 1.23996 10.71L6.29996 15.71C6.48622 15.8947 6.73762 15.9989 6.99996 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg091Undo);
export default __webpack_public_path__ + "static/media/091-undo.af53aafbafa76d20bad92d065a972998.svg";
export { ForwardRef as ReactComponent };